import React,{Component, component} from "react";

export class Home extends Component{
    render(){
        return(
            <div className="colorBG container">
                <h3 className="colorBGBlack">This is home page.</h3>
                <nav className="navbar navbar-expand-sm bg-dark navbar-dark">
        <ul className="navbar-nav">
          <li className="nav-item- m-1">
            <a className="btn btn-dark btn-outline-warning" href="http://www.guildhousegamesllc.com/" target="_blank">Guildhouse Games</a>
          </li>
          <li className="nav-item- m-1">
            <a className="btn btn-dark btn-outline-warning" href="http://playvaria.com" target="_blank">Play Varia</a>
          </li>
          <li className="nav-item- m-1">
            <a className="btn btn-dark btn-outline-warning" href="https://www.twitch.tv/guildhousegames" target="_blank">GuildHouseGames Twitch</a>
          </li>
          <li className="nav-item- m-1">
            <a className="btn btn-dark btn-outline-warning" href="https://discord.gg/njuctx7mY5" target="_blank" >Discord</a>
          </li>
          <li className="nav-item- m-1">
            <a className="btn btn-dark btn-outline-warning" href="https://www.youtube.com/channel/UCde5ziMwkVbXY43_1bWmBLw" target="_blank" >My YouTube</a>
          </li>
        </ul>
      </nav>
                
                
                
            </div>
        )
    }
}